import { useContext } from 'react';

import { RuntimeConfig, RuntimeConfigContext } from '@/config/runtimeConfig';

export function useRuntimeConfig(): RuntimeConfig {
    const context = useContext(RuntimeConfigContext);
    if (!context) {
        throw new Error(
            'useRuntimeConfig must be used within RuntimeConfigProvider',
        );
    }
    return context;
}
